import { getTheme } from 'mol-ui';
import styled from 'styled-components';

export const Content = styled.div`
    height: calc(100% - 70px);
    overflow-y: auto;
`;

export const EmptyMessage = styled.div`
    color: ${ getTheme('textColor') };
    font-size: 14px;
    margin: 0px 0px 0px 10px;
`;
